import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

interface LinkNavigationProps {
    path: string;
    label: string;
}

const LinkNavigation: React.FC<LinkNavigationProps> = ({ path, label }) => {
    const history = useHistory();
    return (
        <a className="btn btn-link text-center p-0 text-small" type="button" onClick={() => history.push(path)}>
            {label}
        </a>
    );
};

LinkNavigation.propTypes = {
    path: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
};

export default LinkNavigation;
